
import { ReactNode } from "react";
import { CarColor } from "../lib/definitions";


export type lapData = {
    bonustxt : Array<string>
    timetxt : Array<string>
    txtnitros : Array<string>
    txtdmg : Array<string>
    color:Array<string>
}

type carStatProp = {
    infos : string,
    color : CarColor
    carid : number
}


const CarStat = (props: carStatProp): ReactNode => {

    const style = { color:'#000000', fontSize: 18, fontWeight: 'bold', backgroundColor: 'rgb('+props.color.r * 255+','+props.color.g* 255+','+props.color.b* 255+')' };
    return ( <span style={style}>{props.infos}</span>   )

}

export default CarStat;